'use client';

import { useEffect } from 'react';

/**
 * 修复 MUI Select 下拉框导致的滚动条问题
 * 当 MUI Select 下拉框打开时，会添加 overflow: hidden 到 body 元素，导致滚动条消失
 * 这个组件会计算滚动条宽度，并在滚动条消失时添加相应的 padding-right 到 body 元素
 * 这样可以防止页面内容在滚动条消失时发生跳动
 */
export default function ScrollLockFix() {
  useEffect(() => {
    // 计算滚动条宽度
    const calculateScrollbarWidth = () => {
      // 创建一个带滚动条的 div
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      document.body.appendChild(outer);

      // 创建一个内部 div
      const inner = document.createElement('div');
      outer.appendChild(inner);

      // 计算滚动条宽度
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

      // 清理
      outer.parentNode?.removeChild(outer);

      return scrollbarWidth;
    };

    // 获取滚动条宽度
    const scrollbarWidth = calculateScrollbarWidth();

    // 创建一个 MutationObserver 来监听 body 的 style 变化
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style' &&
          document.body.style.overflow === 'hidden'
        ) {
          // 当 body 的 overflow 被设置为 hidden 时，添加 padding-right
          const currentPaddingRight = parseInt(document.body.style.paddingRight || '0', 10);
          if (currentPaddingRight < scrollbarWidth) {
            document.body.style.paddingRight = `${scrollbarWidth}px`;
          }
        } else if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style' &&
          document.body.style.overflow !== 'hidden'
        ) {
          // 当 body 的 overflow 不再是 hidden 时，移除 padding-right
          document.body.style.paddingRight = '';
        }
      });
    });

    // 开始观察 body 的 style 变化
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    // 清理函数
    return () => {
      observer.disconnect();
    };
  }, []);

  // 这个组件不渲染任何内容
  return null;
}
